module.exports = __webpack_public_path__ + "assets/img/no-data.cb469cf2.png";